var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8309 13.8319C18.7082 13.9547 18.7001 14.0279 18.7001 14.05C18.7001 14.0721 18.7082 14.1453 18.8309 14.268C18.956 14.3932 19.1673 14.5334 19.4762 14.6641C20.0916 14.9245 20.9836 15.1 22.0001 15.1C23.0166 15.1 23.9086 14.9245 24.524 14.6641C24.8329 14.5334 25.0442 14.3932 25.1693 14.268C25.292 14.1453 25.3001 14.0721 25.3001 14.05C25.3001 14.0279 25.292 13.9547 25.1693 13.8319C25.0442 13.7068 24.8329 13.5665 24.524 13.4358C23.9086 13.1755 23.0166 13 22.0001 13C20.9836 13 20.0916 13.1755 19.4762 13.4358C19.1673 13.5665 18.956 13.7068 18.8309 13.8319ZM19.0086 12.3307C19.8047 11.9939 20.8627 11.8 22.0001 11.8C23.1375 11.8 24.1955 11.9939 24.9916 12.3307C25.3885 12.4986 25.7483 12.7139 26.0179 12.9835C26.2899 13.2556 26.5001 13.6165 26.5001 14.05C26.5001 14.101 26.4972 14.151 26.4916 14.2H26.5001V15.6348C26.5001 15.8768 26.4311 16.0936 26.3228 16.2829V16.5826C26.3228 16.7828 26.4317 16.9671 26.6071 17.0637C28.0212 17.8426 28.9001 19.327 28.9001 20.9423V28.6187C28.9001 29.8091 27.9023 30.7056 26.7115 31.2691C25.4747 31.8544 23.8083 32.2 22.0001 32.2C20.1919 32.2 18.5255 31.8544 17.2887 31.2691C16.0979 30.7056 15.1001 29.8091 15.1001 28.6187L15.1001 20.9423C15.1001 19.327 15.979 17.8426 17.3931 17.0637C17.5685 16.9671 17.6774 16.7828 17.6774 16.5826V16.2828C17.5691 16.0936 17.5001 15.8767 17.5001 15.6348L17.5001 14.2H17.5086C17.503 14.151 17.5001 14.101 17.5001 14.05C17.5001 13.6165 17.7103 13.2556 17.9823 12.9835C18.2519 12.7139 18.6117 12.4986 19.0086 12.3307ZM18.7688 17.1894C18.6252 17.5773 18.3461 17.9087 17.9721 18.1147C16.9404 18.6831 16.3001 19.7652 16.3001 20.9423L16.3001 28.6187C16.3001 29.0748 16.7127 29.669 17.802 30.1845C18.8454 30.6782 20.3289 31 22.0001 31C23.6713 31 25.1549 30.6782 26.1982 30.1845C27.2876 29.669 27.7001 29.0748 27.7001 28.6187V20.9423C27.7001 19.7652 27.0598 18.6831 26.0281 18.1147C25.6541 17.9087 25.375 17.5774 25.2314 17.1894C25.15 17.2279 25.0665 17.2642 24.9813 17.2984C24.1883 17.6166 23.1341 17.8 22.0001 17.8C20.8662 17.8 19.8119 17.6166 19.0189 17.2984C18.9337 17.2642 18.8502 17.2279 18.7688 17.1894ZM24.9916 15.7693C25.0974 15.7245 25.2006 15.6764 25.3001 15.6248V15.6348C25.3001 15.6384 25.2999 15.6511 25.2863 15.6777C25.2716 15.7067 25.2408 15.7517 25.1806 15.8088C25.0567 15.9264 24.8453 16.0599 24.5343 16.1847C23.9158 16.433 23.0201 16.6 22.0001 16.6C20.9802 16.6 20.0844 16.433 19.4659 16.1847C19.155 16.0599 18.9435 15.9264 18.8196 15.8088C18.7594 15.7517 18.7287 15.7067 18.7139 15.6777C18.7003 15.6511 18.7001 15.6384 18.7001 15.6348V15.6248C18.7996 15.6764 18.9028 15.7245 19.0086 15.7693C19.8047 16.1061 20.8627 16.3 22.0001 16.3C23.1375 16.3 24.1955 16.1061 24.9916 15.7693Z",
    fill: "url(#paint0_linear_1781_6573)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8002 22.75C18.1316 22.75 18.4002 23.0186 18.4002 23.35V28.45C18.4002 28.7814 18.1316 29.05 17.8002 29.05C17.4688 29.05 17.2002 28.7814 17.2002 28.45V23.35C17.2002 23.0186 17.4688 22.75 17.8002 22.75Z",
    fill: "url(#paint1_linear_1781_6573)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8002 19.9C18.1316 19.9 18.4002 20.1686 18.4002 20.5V21.1C18.4002 21.4313 18.1316 21.7 17.8002 21.7C17.4688 21.7 17.2002 21.4313 17.2002 21.1V20.5C17.2002 20.1686 17.4688 19.9 17.8002 19.9Z",
    fill: "url(#paint2_linear_1781_6573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_6573",
    x1: 34.3985,
    y1: 10.1265,
    x2: 8.29236,
    y2: 23.1238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1781_6573",
    x1: 18.8783,
    y1: 22.2332,
    x2: 16.1001,
    y2: 22.6227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1781_6573",
    x1: 18.8783,
    y1: 19.7523,
    x2: 16.5952,
    y2: 20.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass);
export default __webpack_public_path__ + "static/media/glass.16bcccf0a04ff8ea33445513c6119ac3.svg";
export { ForwardRef as ReactComponent };